import apiService from '../utils/apiService';

import {
  ADD_SUBMISSION_DATA_SIGNET,
  ADD_SUBMISSION_DATA_SIGNET_START,
  ADD_SUBMISSION_DATA_SIGNET_ERROR,
  CLEAR_ERROR_SUBMISSION_DATA_SIGNET,
  GET_SUBMISSION_DATA_SIGNET_BY_SIGNET,
  GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_START,
  GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_ERROR,
  ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK,
  ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_START,
  ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_ERROR,
} from './types';

import {
  submissionDataSignetAddWithAttachmentPath,
  submissionDataSignetBySignetFindByIdPath,
  submissionDataSignetAddWithOneAttachmentPath,
} from '../constants/apiEndpoints';

import { findSubmissionDataSignetDestroyedLatestVersione } from './submissionDataSignetDestroyed';
import { findSubmissionDataSignetLookLatestVersione } from './submissionDataSignetLook';
import {
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';
import { createNotification } from '../utils';

const clearError = () => {
  return {
    type: CLEAR_ERROR_SUBMISSION_DATA_SIGNET,
  };
};

const addSubmissionDataSignetStart = () => {
  return {
    type: ADD_SUBMISSION_DATA_SIGNET,
  };
};
const addSubmissionDataSignetSuccessfully = (data) => {
  return {
    type: ADD_SUBMISSION_DATA_SIGNET_START,
    payload: data,
  };
};
const addSubmissionDataSignetUnsuccessfully = (err) => {
  return {
    type: ADD_SUBMISSION_DATA_SIGNET_ERROR,
    payload: err,
  };
};

const addSubmissionDataSignetWithLookStart = () => {
  return {
    type: ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK,
  };
};
const addSubmissionDataSignetWithLookSuccessfully = (data) => {
  return {
    type: ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_START,
    payload: data,
  };
};
const addSubmissionDataSignetWithLookUnsuccessfully = (err) => {
  return {
    type: ADD_SUBMISSION_DATA_SIGNET_WITH_LOOK_ERROR,
    payload: err,
  };
};

const getSubmissionDataSignetBySignetStart = () => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_START,
  };
};
const getSubmissionDataSignetBySignetSuccessfully = (data) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_BY_SIGNET,
    payload: data,
  };
};
const getSubmissionDataSignetBySignetUnsuccessfully = (err) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_BY_SIGNET_ERROR,
    payload: err,
  };
};

export const createSubmissionDataSignetWithLook = (
  submissionDataSignet,
  callback,
  NotificationMessages,
  enums,
  signetStatus
) => {
  return (dispatch) => {
    dispatch(addSubmissionDataSignetStart());
    return apiService
      .post(
        submissionDataSignetAddWithOneAttachmentPath(),
        submissionDataSignet
      )
      .then((response) => {
        dispatch(addSubmissionDataSignetSuccessfully(response.data));
        callback();
        signetStatus === enums.COMPLEMENT_REQUIRED.value &&
          createNotification(
            notificationTypeSuccess,
            NotificationMessages.submissionDataSignet,
            NotificationMessages.successSubmissionDataUpdate
          );
        signetStatus === enums.APPROVED.value &&
          createNotification(
            notificationTypeSuccess,
            NotificationMessages.submissionDataSignet,
            NotificationMessages.successSubmissionDataCreate
          );
      })
      .catch((err) => {
        dispatch(addSubmissionDataSignetUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          NotificationMessages.submissionDataSignet,
          NotificationMessages.unsuccessSubmissionData
        );
      });
  };
};

export const createSubmissionDataSignet = (
  submissionDataSignet,
  callback,
  message
) => {
  return (dispatch) => {
    dispatch(addSubmissionDataSignetWithLookStart());
    return apiService
      .post(submissionDataSignetAddWithAttachmentPath(), submissionDataSignet)
      .then((response) => {
        dispatch(addSubmissionDataSignetWithLookSuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          message.submissionDataSignet,
          message.successSubmissionDataUpdate
        );
      })
      .catch((err) => {
        dispatch(
          addSubmissionDataSignetWithLookUnsuccessfully(err?.response?.data)
        );
        createNotification(
          notificationTypeError,
          message.submissionDataSignet,
          message.unsuccessSubmissionData
        );
      });
  };
};

export const findSubmissionDataSignetBySignetId = (signetId) => {
  return (dispatch) => {
    dispatch(getSubmissionDataSignetBySignetStart());
    return apiService
      .get(submissionDataSignetBySignetFindByIdPath(signetId))
      .then((response) => {
        dispatch(getSubmissionDataSignetBySignetSuccessfully(response.data));
        response.data &&
          dispatch(
            findSubmissionDataSignetLookLatestVersione(response.data.id)
          );
        response.data &&
          dispatch(
            findSubmissionDataSignetDestroyedLatestVersione(response.data.id)
          );
      })
      .catch((err) => {
        dispatch(
          getSubmissionDataSignetBySignetUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const deleteErrorSubmissionDataSignet = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};
